import colors from '../../../../lib/colors'

import { button } from '../../../../component/component'

import refreshData from '../../lib/refreshData'

export default function(o){

  var click =
    function(){
      if(!refresh.getDisabled()){      
        refresh.setDisabled(true)
        refreshData(o,function(error){
          if(error){
            refresh.setDisabled(false)
            refresh.setColor(colors.red.s_500)
          } else {
            o.edit.update()
            o.search.update()
            refresh.setDisabled(false)
            refresh.setColor(colors.white)
          }
        })
      }
    }

  var refresh =
    button(null,'fi-refresh')
    .css({
      position: 'absolute',
      display: 'inline-block',
      right: 0,
    })
    .click(click)

  return refresh

}


// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/refresh/refresh.js